import React, { useContext, useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'

import Rockets from '../../assets/rockets.svg'
import AdxDropzoneCompanyImage from 'components/reusable/AdxDropzoneCompanyImage'
import AdxInput from 'components/custom/AdxInput'
import { superAdminOnboardingLink } from 'module/sign-up/config/superAdminUrl'
import { SuperAdminOnboardingContext } from 'module/sign-up/context/SuperAdminOnboardingContext'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxButton from 'components/custom/AdxButton'

const StepTwo = () => {
  const { savedSuperAdminOnboardingSession, setSuperAdminOnboardingSession } = useContext(
    SuperAdminOnboardingContext
  )
  const [photo, setPhoto] = useState(savedSuperAdminOnboardingSession.profile_photo || null)
  const [isError, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const navigate = useNavigate()
  const handleContinue = () => {
    if (validateName(savedSuperAdminOnboardingSession.name)) {
      navigate(superAdminOnboardingLink(3))
    } else {
      setError(true)
      setErrorMessage('Name must be at least 10 characters')
    }
  }
  const handleBack = () => {
    navigate(superAdminOnboardingLink(1))
  }

  // save profile photo
  useEffect(() => {
    setSuperAdminOnboardingSession({
      ...savedSuperAdminOnboardingSession,
      profile_photo: photo,
    })
  }, [photo])

  // save employee name

  // validation

  const validateName = (name) => {
    if (/^.{10,}$/.test(name)) {
      return true
    }
    return false
  }
  const handleChange = (e) => {
    setError(false)
    setErrorMessage('')
    setSuperAdminOnboardingSession({
      ...savedSuperAdminOnboardingSession,
      name: e.target.value,
    })
  }

  return (
    <OnboardingContainer bgColorRight="white.main">
      <Box
        height={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'flex-end' }}
        alignItems="center"
      >
        <Box
          component="img"
          src={Rockets}
          position="fixed"
          bottom={0}
          right={0}
          width="calc(100vw * 0.8)"
          display={{ xs: 'none', lg: 'block' }}
        />
        <Box
          width={{ xs: '100%', lg: '500px' }}
          height={{ xs: '75vh', lg: '70vh' }}
          maxHeight={{ xs: 'unset', lg: '650px' }}
          mr={{ lg: 7.6875 }}
          p={{ xs: 2, lg: 0 }}
          position={'relative'}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box mb={4} display="flex" flexDirection="column" gap={0.5}>
            <Typography variant="body1" color="alternate.main" fontWeight="bold">
              Step 1
            </Typography>
            <Typography variant="h4" textAlign="justify" color="dark-text.main" fontWeight="bold">
              Personal Details
            </Typography>
            <Box display="flex" justifyContent="center">
              <Box
                display="flex"
                justifyContent="center"
                flexDirection="column"
                alignItems="center"
                py={3}
              >
                <AdxDropzoneCompanyImage
                  photoUpload={photo}
                  setPhotoUpload={setPhoto}
                  radiusLength={90}
                />
                <Typography variant="body1" width="100%" textAlign="center">
                  Profile Picture
                </Typography>
              </Box>
            </Box>
            <AdxInput
              label="Employee name"
              sxLabel={{
                color: 'black.main' /*, fontSize: "30px!important" */,
              }}
              sx={{
                marginBottom: '16px',
              }}
              size="standard"
              placeholder="Employee name"
              onChange={handleChange}
              value={savedSuperAdminOnboardingSession.name}
              isErrorShown={isError}
              errorMessage={<AdxErrorMessage>{errorMessage}</AdxErrorMessage>}
            />
          </Box>
          <Box width={1} mt={10} display="flex" gap={1}>
            <AdxButton
              variant={'outlined'}
              onClick={handleBack}
              sx={{ minWidth: '20px', pl: 3, borderWidth: 2 }}
            >
              {<ArrowBackIosIcon />}
            </AdxButton>
            <AdxButton
              fullWidth
              onClick={handleContinue}
              disabled={
                ![
                  Boolean(savedSuperAdminOnboardingSession?.name),
                  Boolean(savedSuperAdminOnboardingSession?.profile_photo),
                ].every((item) => item === true)
              }
            >
              Continue
            </AdxButton>
          </Box>
        </Box>
      </Box>
    </OnboardingContainer>
  )
}

export default StepTwo
